import { Config, initialConfig, Company, AuthData } from 'config';
import { setItemToStore } from 'helpers/utils';

//Action types
export const SET_CONFIG = 'SET_CONFIG';
export const REFRESH = 'REFRESH';
export const RESET = 'RESET';
// For company state
export const SET_COMPANY_LOADING = 'SET_COMPANY_LOADING';
export const SET_COMPANY_SUCCESS = 'SET_COMPANY_SUCCESS';
export const SET_COMPANY_ERROR = 'SET_COMPANY_ERROR';
// For user state
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const SET_AUTH_SUCCESS = 'SET_AUTH_SUCCESS';
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const LOGOUT = 'LOGOUT';

//Action ts type
export type ACTIONTYPE =
  | { type: typeof SET_CONFIG; payload: Partial<Config> }
  | { type: typeof REFRESH }
  | { type: typeof RESET }
  | { type: typeof SET_COMPANY_LOADING }
  | { type: typeof SET_COMPANY_SUCCESS; payload: Company }
  | { type: typeof SET_COMPANY_ERROR; payload: string }
  | { type: typeof SET_AUTH_LOADING }
  | { type: typeof SET_AUTH_SUCCESS; payload: AuthData }
  | { type: typeof SET_AUTH_ERROR; payload: string }
  | { type: typeof LOGOUT };

export const configReducer = (state: Config, action: ACTIONTYPE) => {
  switch (action.type) {
    case SET_CONFIG: {
      const { payload } = action;
      Object.keys(payload).forEach(key => {
        if (
          [
            'theme',
            'navbarTopShape',
            'navbarPosition',
            'navbarTopAppearance',
            'navbarVerticalAppearance',
            'isRTL',
            'isDark',
            'isNavbarVerticalCollapsed',
            'isChatWidgetVisible'
          ].includes(key)
        ) {
          setItemToStore(key, String(payload[key as keyof Config]));
        }
      });
      return {
        ...state,
        ...payload
      };
    }
    case SET_COMPANY_LOADING:
      return {
        ...state,
        companyState: {
          ...state.companyState,
          isLoading: true,
          error: null
        }
      };
    case SET_COMPANY_SUCCESS:
      return {
        ...state,
        companyState: {
          company: action.payload,
          isLoading: false,
          error: null
        }
      };
    case SET_COMPANY_ERROR:
      return {
        ...state,
        companyState: {
          ...state.companyState,
          isLoading: false,
          error: action.payload
        }
      };
    case SET_AUTH_LOADING:
      return {
        ...state,
        authState: {
          ...state.authState,
          isLoading: true,
          error: null
        }
      };
    case SET_AUTH_SUCCESS:
      return {
        ...state,
        authState: {
          authData: action.payload,
          isLoading: false,
          error: null
        }
      };
    case SET_AUTH_ERROR:
      return {
        ...state,
        authState: {
          ...state.authState,
          isLoading: false,
          error: action.payload
        }
      };
    case LOGOUT:
      return {
        ...state,
        authState: {
          authData: {
            user: null,
            modules: [],
            isAuthenticated: false
          },
          isLoading: false,
          error: null
        }
      };
    case REFRESH:
      return {
        ...state
      };
    case RESET:
      localStorage.clear();
      return {
        ...initialConfig
      };
    default:
      return state;
  }
};
